/* src/app/shared/sub-features/modal-feature-info/info-modal.component.scss */
:host {
  display: block;
  height: 100%;
  max-height: 80vh;
  overflow-y: auto;
  background: var(--main-background);
}
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 15px 12px;
  margin: 0;
  border-radius: 16px;
}
.title {
  text-align: center;
  margin-bottom: 25px;
  text-transform: uppercase;
}
.info,
.phone-number {
  line-height: 140%;
  text-align: center;
  white-space: pre-line;
  margin-bottom: 10px;
}
.btns {
  padding-top: 10px;
  margin-top: 10px;
  width: 100%;
  border-top: 1px solid var(--secondary-background);
}
.btns ion-button:last-child {
  margin-top: 10px;
}
.btns .close {
  --background: var(--btn-background3);
  color: var(--text-color4);
}
/*# sourceMappingURL=info-modal.component.css.map */
